export const heapClearProperties = () => {
  if (window.heap) {
    window.heap.clearEventProperties();

    return true;
  }
};
